// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1nMU2","title":"AfterImages45_title__3FGxn","images":"AfterImages45_images__Xowmk"};